module.exports = __webpack_public_path__ + "6133f8579c08292852f6d2c01817df97.svg";